function bindEscKey(e) {
  if (e.key === 'Escape') {
    onModalClose();
  }
}

function onModalOpen(modal) {
  modal.classList.add('modal--visible');
  document.addEventListener('keydown', bindEscKey);
}

function onModalClose() {
  const modals = document.querySelectorAll('.modal--visible');
  modals.forEach((modal) => {
    modal.classList.remove('modal--visible');
  });
  document.removeEventListener('keydown', bindEscKey);
}

function init() {
  document.querySelectorAll('.js-modal-open').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      onModalOpen(document.getElementById(`${el.href.split('#')[1]}`));
    });
  });
  document.querySelectorAll('.js-modal-close').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      onModalClose();
    });
  });
}

export { init };
